













import Vue from 'vue';
import Component from 'vue-class-component';
import ChevronDoubleRightIcon from 'vue-material-design-icons/ChevronDoubleRight.vue';
import ApiSimulador from '@/plugins/ApiSimulador';
import RdStation from '@/plugins/RdStation';

@Component({
    components: { ChevronDoubleRightIcon }
})
export default class DetalhesProsseguir extends Vue {

    get cotacao () {
        return this.$store.state.cotacao;
    }

    get email() {
        return this.$store.getters.get_email;
    }

    public onClick () {
        this.$router.push({
            name: 'resumo'
        });

        const data = this.$store.getters.cotacao;
        ApiSimulador.update(data).then();

        RdStation.conversion({
            nome: this.cotacao.nome,
            email: this.email,
            identificador: "Protruck - Simulador Plano",
            cobertura: this.cotacao.cobertura,
            valor_cobertura: this.cotacao.valor_cobertura,
            valor_adesao: this.cotacao.valor_adesao,
            valor_mensalidade: this.$store.getters.mensal,
        }).then();

        window.fbq('track', 'Lead');
        window.fbq('track', 'AddToCart', {
            value:    this.$store.getters.valor_mensalidade,
            currency: 'BRL',
        });
    }

}
